goog.provide('el8.uiwidget.NewInfoField');

goog.require('el8.util.dom');
goog.require('el8.template.uiwidget.NewInfoField');
goog.require('el8.util.consts');


/**
 * This is a modification of infoField.js (which lives in el8/core/service)
 * which we only use for the onboarding app (www.secure).
 */
(function() {

    var BaseHelper = (function(spec) {

        this._infoFieldClass = 'new-info-field';
        this._infoTextClass = 'el8TextFieldInfoText';
        this._transparentClass = 'el8Transparent';
        this._fieldClass = 'el8TextFieldPosition';
        this._activeWrapClass = 'el8InFocus';

        this.noInput = function(field) {
            return Boolean(field.val() === null || field.val().trim() === '' ||
                field.val().length === 0);
        };

        this.getFontSizeClass = function(size) {
            switch(size) {
                case 'large':
                    return 'el8LargeFontSize';
                case 'xl':
                    return 'el8ExtraLargeFontSize';
                default:
                    return 'el8StandardFontSize';
            }
        };

        this.getWrapper = function(field) {
            // TODO Can we commit to always just going one step up for applying wrapClass?
            return field.parent();
        };

        this.resetInfoText = function(field) {
            field.prevAll('.info-field-text').addClass(this._infoTextClass)
                .removeClass(this._transparentClass);
            field.addClass(this._transparentClass);
            field.parent().removeClass(this._activeWrapClass);
            if (el8.util.consts.SPELLCHECK) { field.attr('spellcheck', false); }
        };

        this.applyActiveInputClass = function(field) {
            field.prevAll('.info-field-text').removeClass(this._infoTextClass)
                .addClass(this._transparentClass);
            field.removeClass(this._transparentClass);
            field.parent().addClass(this._activeWrapClass);
            if (el8.util.consts.SPELLCHECK) { field.attr('spellcheck', true); }
        };

        this.removeInfoClass = function(field) {
            field.prevAll('.info-field-text').removeClass(this._infoTextClass)
                .addClass(this._transparentClass);
            field.removeClass(this._transparentClass);
            field.parent().removeClass(this._activeWrapClass);
            if (el8.util.consts.SPELLCHECK) { field.attr('spellcheck', true); }
        };

        var that = this;

        $(document)
            .on('focus', ':input.'+this._infoFieldClass, function(e) {
                var field = $(this);
                var $wrapper = that.getWrapper(field);
                field.outerWidth($wrapper.width());
                if (that.noInput(field)) {
                    field.val('');
                }
                if (!field.prop('disabled') && !field.closest('fieldset').prop('disabled')) {
                    that.applyActiveInputClass(field);
                }
                return false;
            }).on('blur', ':input.'+this._infoFieldClass, function(e) {
                var field = $(this);
                if (that.noInput(field)) {
                    that.resetInfoText(field);
                } else {
                    that.removeInfoClass(field);
                }
            }).on('select', ':input.'+this._infoFieldClass, function(e) {
                var field = $(this);
                if (that.noInput(field)) {
                    e.preventDefault();
                    return false;
                }
                return true;
            }).on('keydown', ':input.'+this._infoFieldClass, function(e) {
                var field = $(this);
                if (e.keyCode === KEYS.ESC) {
                    field.blur();
                }
            }).on('paste', ':input.'+this._infoFieldClass, function(e) {
                var field = $(this);
                if (that.noInput(field)) {
                    that.applyActiveInputClass(field);
                }
            });

        $(document)
            .on('keyup', 'textarea.'+this._infoFieldClass, function(e) {
                if ($(this).attr('_nogrow')) { return; }
                var field = $(this);
                var wrapper = $(this).attr('_wrapper');
                var $wrapper = wrapper ? $(this).closest(wrapper) : null;
                if ($(this).attr('_doshrink')) {
                    el8.util.dom.growShrinkTextarea(field, $wrapper, $(this).attr('height'));
                } else {
                    el8.util.dom.adjustTextareaHeight(field, $wrapper);
                }
            });

        return this;

    })();

    el8.uiwidget.NewInfoField = function(spec) {

        this._isInit = false;

        this._field = spec.field;
        this._doShrink = (spec.doShrink === true);  // defaults to false
        this._noGrow = (spec.noGrow === true);      // defaults to false
        this._maxLength = spec.maxLength || null;
        this._wrapper = spec.wrapper || null;

        this._size = spec.size || 'standard'; // choices are "standard", "large", "xl"

        this._height = spec.height ||
            (this._size === 'standard' ? el8.util.consts.DEFAULT_FIELD_HEIGHT :
             (this._size === 'large' ? el8.util.consts.LARGE_FIELD_HEIGHT :
              (this._size === 'xl' ? el8.util.consts.XL_FIELD_HEIGHT : '')));

        if (spec.rows && this._height) {
            this._height = this._height * spec.rows;
        }

        this._infoText = spec.infoText || '';

        // TODO ? This is what we did before
        this.init();

    };
    el8.uiwidget.NewInfoField.prototype.init = function() {

        if (!this._isInit) {

            this._field.addClass(BaseHelper._infoFieldClass)
                .addClass(BaseHelper.getFontSizeClass(this._size));

            if (this._infoText) { this._field.addClass(BaseHelper._fieldClass); }
            this._field.attr('spellcheck', 'false');
            this._field.attr('autocomplete', 'off');

            if (this._doShrink) {
                this._field.attr('_doshrink', true);
            } else if (this._noGrow) {
                this._field.attr('_nogrow', true);
            }

            if (this._maxLength) {
                this._field.attr('maxlength', this._maxLength);
            }
            if (this._height) {
                this._field.attr('height', this._height);
                this._field.css({'overflow': 'hidden'});
                this._field.height(this._height);
            } else {
                this._field.removeAttr('height');
            }

            if (this._wrapper) {
                this._field.attr('_wrapper', this._wrapper);
            }

            // Insert info text div
            if (this._infoText) {
                var $infoTextDiv = $(el8.template.uiwidget.NewInfoField.infoTextElt({
                    infoText: this._infoText,
                    fontSizeClass: BaseHelper.getFontSizeClass(this._size)
                }));
                $infoTextDiv.height(this._height).insertBefore(this._field);
            }

            // Add size to the field
            var $wrapper = BaseHelper.getWrapper(this._field);
            var paddingTop = $wrapper.css("padding-top").replace("px", "") * 1;
            var paddingLeft = $wrapper.css("padding-left").replace("px", "") * 1;
            this._field.css('top', paddingTop)
                .css('left', paddingLeft);

            this._isInit = true;
        }

        // Allow infoText to be either driven by arg or by field attr
        if (this._infoText) {
            this._field.attr('_infotext', this._infoText);
        } else {
            this._infoText = this._field.attr('_infotext') || '';
        }

        // Initialize with info text
        BaseHelper.resetInfoText(this._field);
    };
    el8.uiwidget.NewInfoField.prototype.getVal = function() {
        return BaseHelper.noInput(this._field) ? '' : this._field.val();
    };
    el8.uiwidget.NewInfoField.prototype.setVal = function(value) {
        if (value !== null) {
            this._field.val(value);
            if (BaseHelper.noInput(this._field)) {
                this.init();
            } else {
                BaseHelper.removeInfoClass(this._field);
                if (!this._noGrow) {
                    el8.util.dom.adjustTextareaHeight(this._field);
                }
            }
        }
        return this;
    };
    el8.uiwidget.NewInfoField.prototype.getInputField = function() {
        return this._field;
    };
    el8.uiwidget.NewInfoField.prototype.blur = function() {
        this._field.blur();
    };
    el8.uiwidget.NewInfoField.prototype.getInfoText = function() {
        return this._infoText;
    };
    el8.uiwidget.NewInfoField.prototype.getMaxLength = function() {
        return this._maxLength;
    };
    // TODO This can be replaced with getVal()
    el8.uiwidget.NewInfoField.prototype.noInput = function() {
        return BaseHelper.noInput(this._field);
    };

})();
